export enum KitType {
  HOME = 'home',
  AWAY = 'away',
  THIRD = 'third',
  GOALKEEPER = 'goalkeeper',
}

/** Human-readable labels for the kit type picker. */
export const KIT_TYPE_LABELS: Record<KitType, string> = {
  [KitType.HOME]: 'Домашняя',
  [KitType.AWAY]: 'Гостевая',
  [KitType.THIRD]: 'Третья',
  [KitType.GOALKEEPER]: 'Вратарская',
};

/** Kit types in the order they are shown in the editor. */
export const ALL_KIT_TYPES: KitType[] = [KitType.HOME, KitType.AWAY, KitType.THIRD, KitType.GOALKEEPER];

/** Проверка сегмента URL: `/teams/:id/kits/:kitType` принимает только эти значения. */
export const isKitType = (value?: string): value is KitType => ALL_KIT_TYPES.includes(value as KitType);
